module.exports = __webpack_public_path__ + "img/Rodrigo.11adab5a.png";